// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const Toaster = () => {
//   return (
//     <ToastContainer
//       position="top-center"
//       autoClose={500}
//       hideProgressBar={false}
//       newestOnTop={false}
//       closeOnClick
//       rtl={false}
//       pauseOnFocusLoss
//       draggable
//       pauseOnHover
//       toastStyle={{
//         borderRadius: '0.375rem',
//         padding: '1rem 2rem',
//         fontSize: '1rem',
//         fontWeight: '600',
//       }}
//     />
//   );
// };

// export const showSuccessToast = (message) => {
//   toast.success(message, {
//     position: "top-center",
//     autoClose: 3000,
//     hideProgressBar: false,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: true,
//     progress: undefined,
//     style: {
//       background: '#28a745',
//       color: '#fff',
//       fontWeight: '600',
//       padding: '1rem 2rem',
//       borderRadius: '0.375rem',
//       fontSize: '1rem',
//       boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
//     },
//   });
// };

// export const showErrorToast = (message) => {
//  toast.error(message, {
//     position: "top-center",
//     autoClose: 4000,
//     hideProgressBar: true,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: false,
//     style: {
//       background: '#ff4d4f',  
//       color: '#fff',
//       fontWeight: '500',
//       padding: '12px 20px',
//       borderRadius: '8px',
//       fontSize: '0.95rem',
//       boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//     },
//   });
// };


// export default Toaster;
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Toaster = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar
      closeOnClick
      pauseOnHover
      draggable
      newestOnTop
      theme="colored"
      toastStyle={{
        borderRadius: "16px",
        padding: "20px",
        fontSize: "15px",
        fontWeight: "500",
        boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
        backdropFilter: "blur(10px)",
      }}
    />
  );
};
export const showSuccessToast = (content, options = {}) => {
  toast.success(
    <div className="flex flex-col items-center text-center">
      <div className="font-semibold text-lg">
        {content.title || "Success"}
      </div>
      {content.message && (
        <div className="text-sm mt-1 opacity-90">
          {content.message}
        </div>
      )}
      {content.button && (
        <button
          onClick={content.button.onClick}
          className="mt-4 px-5 py-2 bg-white text-green-600 font-semibold rounded-full shadow-md hover:scale-105 transition-all duration-300"
        >
          {content.button.label}
        </button>
      )}
    </div>,
    {
      ...options,
    }
  );
};
export const showErrorToast = (message, options = {}) => {
  toast.error(
    <div className="flex flex-col items-center text-center">
      <div className="text-2xl mb-2">⚠️</div>
      <div className="font-semibold text-lg">
        Something went wrong
      </div>
      <div className="text-sm mt-1 opacity-90">
        {message}
      </div>
    </div>,
    {
      ...options,
    }
  );
};
export const showErrorWithDetailsToast = (
  message,
  errorData,
  onViewDetails
) => {
  toast.error(
    <div className="flex flex-col items-center text-center">
      <div className="text-2xl mb-2">❌</div>
      <div className="font-semibold text-lg">
        Request Failed
      </div>
      <div className="text-sm mt-1 opacity-90">
        {message}
      </div>

      <button
        onClick={onViewDetails}
        className="mt-4 px-5 py-2 bg-white text-red-600 font-semibold rounded-full shadow-md hover:scale-105 transition-all duration-300"
      >
        View Details
      </button>
    </div>,
    { autoClose: false }
  );
};

export const dismissToast = () => {
  toast.dismiss();
};

export default Toaster;